import { v4 as uuidv4 } from 'uuid';

export function Chevron({ css = { transform: "rotate(-90deg)" } }) {
    const id = uuidv4();
  return (
    <svg
      aria-label="chevron"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      style={css}
    >
      <mask
        id={id}
        width="24"
        height="24"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path fill="#D9D9D9" d="M0 0h24v24H0z" />
      </mask>
      <g mask={`url(#${id})`}>
        <path
          fill="#14007E"
          d="m12 15.4-6-6L7.4 8l4.6 4.6L16.6 8 18 9.4l-6 6Z"
        />
      </g>
    </svg>
  );
}
